import { logActivity } from "../services/dataService";

/**
 * Helper function to log user activities
 * @param {Object} params - Activity parameters
 * @param {string} params.userId - ID of the user performing the action
 * @param {string} params.userName - Name of the user performing the action
 * @param {string} params.userEmail - Email of the user performing the action
 * @param {string} params.action - Action performed (e.g., "UPDATE_STUDENT", "DELETE_TUTOR", "EDIT_LESSON")
 * @param {string} params.entityType - Type of entity affected (e.g., "student", "tutor", "lesson")
 * @param {string} params.entityId - ID of the entity affected
 * @param {string} params.entityName - Name/identifier of the entity affected
 * @param {Object} params.details - Additional details about the action (new values)
 * @param {Object} params.before - Previous values before the change (for comparison)
 * @param {Object} params.after - New values after the change (same as details, but explicit)
 * @param {string} params.description - Human-readable description of the action
 */
export const logUserActivity = async ({
  userId,
  userName,
  userEmail,
  action,
  entityType,
  entityId,
  entityName,
  details = {},
  before = {},
  after = {},
  description,
}) => {
  try {
    // Use after if provided, otherwise fall back to details
    const afterValues = Object.keys(after).length > 0 ? after : details;
    
    const activityData = {
      userId,
      userName: userName || "Unknown",
      userEmail: userEmail || "Unknown",
      action,
      entityType,
      entityId,
      entityName: entityName || "Unknown",
      details: afterValues, // Keep for backward compatibility
      before, // Previous values
      after: afterValues, // New values
      description:
        description ||
        `${userName || "User"} performed ${action} on ${entityType} ${entityName || entityId || ""}`,
    };

    await logActivity(activityData);
  } catch (error) {
    console.error("Failed to log activity:", error);
    // Don't throw error - activity logging should not break the main flow
  }
};

